import {BaseCriteriaModel} from '../base-criteria.model';
import {Optional} from 'typescript-optional';

export class StockTakeSessionHdrQueryCriteriaClass extends BaseCriteriaModel {
  code?: Optional<string> = Optional.empty();
  name?: Optional<string> = Optional.empty();
  guid_comp?: Optional<string> = Optional.empty();
  guid_branch?: Optional<string> = Optional.empty();
  guid_location?: Optional<string> = Optional.empty();
  description?: Optional<string> = Optional.empty();
  date_start?: Optional<string> = Optional.empty();
  date_end?: Optional<string> = Optional.empty();
  date_created?: Optional<string> = Optional.empty();
  date_lastupdated?: Optional<string> = Optional.empty();
}

export class StockTakeSessionHdrCriteriaModelQuery {
  query = '';

  constructor(stockTakeSessionHdrCriteriaModel: StockTakeSessionHdrQueryCriteriaClass) {

    if (!stockTakeSessionHdrCriteriaModel) {
      return;
    }

    this.query += stockTakeSessionHdrCriteriaModel.code.filter(x => x !== '').map(x => '&code=' + x).orElse('');
    this.query += stockTakeSessionHdrCriteriaModel.name.filter(x => x !== '').map(x => '&name=' + x).orElse('');
    this.query += stockTakeSessionHdrCriteriaModel.guid_comp.filter(x => x !== '').map(x => '&guid_comp=' + x).orElse('');
    this.query += stockTakeSessionHdrCriteriaModel.guid_branch.filter(x => x !== '').map(x => '&guid_branch=' + x).orElse('');
    this.query += stockTakeSessionHdrCriteriaModel.guid_location.filter(x => x !== '').map(x => '&guid_location=' + x).orElse('');
    this.query += stockTakeSessionHdrCriteriaModel.description.filter(x => x !== '').map(x => '&description=' + x).orElse('');
    this.query += stockTakeSessionHdrCriteriaModel.date_start.filter(x => x !== '').map(x => '&date_start=' + x).orElse('');
    this.query += stockTakeSessionHdrCriteriaModel.date_end.filter(x => x !== '').map(x => '&date_end=' + x).orElse('');
    this.query += stockTakeSessionHdrCriteriaModel.date_created.filter(x => x !== '').map(x => '&date_created=' + x).orElse('');
    this.query += stockTakeSessionHdrCriteriaModel.date_lastupdated.filter(x => x !== '').map(x => '&date_lastupdated=' + x).orElse('');

    this.query += '&status=' + stockTakeSessionHdrCriteriaModel.status;
    this.query += '&orderBy=' + stockTakeSessionHdrCriteriaModel.orderBy;
    this.query += '&order=' + stockTakeSessionHdrCriteriaModel.order;
    this.query += '&offset=' + stockTakeSessionHdrCriteriaModel.offset + '&limit=' + stockTakeSessionHdrCriteriaModel.limit;
  }
}
